import useStyled from "../../core/hooks/useStyled";

const { styled } = useStyled();

const StyledDiv = styled("div")(({ theme }) => ({
  "& img": {
    width: 50,
  },
}));

export const getAcademyIcon = (thumnailUrl, halo = false) => {
  if (thumnailUrl) {
    if (halo) {
      // Path for the academy thumbnail icon in the academies carousel with the background color
      let haloThumnailUrl = thumnailUrl?.replace(".svg", "-halo.svg");
      return <img src={haloThumnailUrl}></img>;
    }
    // Path for the academy thumbnail icon in the heroes cards in the home screen without background color
    return (
      <StyledDiv>
        <img src={thumnailUrl}></img>
      </StyledDiv>
    );
  } else return null;
};
